export default function PasswordCriteria() {
  const PASSWORD_CRITERIA = [
    { regex: /.{8,20}/, message: "Between 8 and 20 characters", key: 'length' },
    { regex: /[A-Z]/, message: "At least one uppercase letter", key: 'uppercase' },
    { regex: /[a-z]/, message: "At least one lowercase letter", key: 'lowercase' },
    { regex: /\d/, message: "At least one number", key: 'number' },
    { regex: /[@$!%*?&]/, message: "At least one special character (@$!%*?&)", key: 'special' },
  ];
    return (
        PASSWORD_CRITERIA
    )
}